const FENCE = /^\s*(```|~~~)/;
const HEADING = /^(\s*)#{1,6}\s+/;
const BULLET = /^(\s*)[-*+]\s+/;

/** Inline markup on one line of prose: bold, italics, inline code and links,
 *  reduced to their text. Single underscores are left alone, since names
 *  like P_TECH_f452 are full of them. */
function plainInline(line: string): string {
  return line
    .replace(/\*\*(.+?)\*\*/g, '$1')
    .replace(/__(.+?)__/g, '$1')
    .replace(/(^|[\s(])\*(\S(?:.*?\S)?)\*(?=[\s).,;:!?]|$)/g, '$1$2')
    .replace(/`([^`]+)`/g, '$1')
    .replace(/\[([^\]]+)\]\(([^)\s]+)\)/g, '$1 ($2)');
}

/**
 * Markdown, as an improved prompt comes back, turned into plain text that
 * reads well in the composer's textarea: no ** or __ markers, "•" for list
 * bullets with their indents kept, headings without their hashes, links as
 * "text (url)". Numbered lists and line breaks stay as written, and fenced
 * code is left untouched.
 */
export function markdownToPlainText(markdown: string): string {
  let inFence = false;
  return markdown
    .split('\n')
    .map((line) => {
      if (FENCE.test(line)) {
        inFence = !inFence;
        return line;
      }
      if (inFence) return line;
      const bullet = BULLET.exec(line);
      if (bullet) {
        return `${bullet[1]}• ${plainInline(line.slice(bullet[0].length))}`;
      }
      return plainInline(line.replace(HEADING, '$1'));
    })
    .join('\n');
}
